import React from "react";
import { Calendar } from "lucide-react";
import AdminCrudPage from "./AdminCrudPage";
import { StateBadge } from "./AdminLayout";
import { apiGet, apiPost, apiPut } from "./adminApi";

const fields = [
  { name: "academicYearCode", label: "Academic Year Code", type: "text", required: true, placeholder: "e.g. 2025" },
  { name: "academicYearName", label: "Academic Year Name", type: "text", required: true, placeholder: "e.g. 2025-2026" },
];

export default function AcademicYearsPage() {
  return (
    <AdminCrudPage
      title="Academic Years"
      subtitle="Academic years used by applications, selection settings and claims"
      icon={Calendar}
      entityName="academic year"
      queryKey="adminAcademicYears"
      fetchAll={() => apiGet("hec/academic/admin/all")}
      createItem={(values) => apiPost("hec/academic/admin/create", values)}
      updateItem={(id, values, row) => apiPut(`hec/academic/admin/${id}`, { ...values, state: row.state })}
      searchKeys={["academicYearCode", "academicYearName"]}
      columns={[
        { key: "academicYearCode", label: "Code", render: (r) => <span className="font-mono text-gray-700">{r.academicYearCode}</span> },
        { key: "academicYearName", label: "Academic Year", render: (r) => <span className="font-semibold text-gray-900">{r.academicYearName}</span> },
        { key: "state", label: "Status", render: (r) => <StateBadge state={r.state} /> },
      ]}
      fields={fields}
    />
  );
}
